import { IFilterObject } from '../../components/FilterComponent'
import colors from '../../constants/colors'

const testFilter: IFilterObject[] = [
  {
    title: 'Incident Type',
    value: 'incident_type',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Threat',
        value: 'THREAT',
        checked: false,
        section: false,
      },
      {
        title: 'Assault',
        value: 'ASSAULT',
        checked: false,
        section: false,
      },
      {
        title: 'Bullying',
        value: 'BULLYING',
        checked: false,
        section: false,
      },
      {
        title: 'Intimate partner violence',
        value: 'INTIMATE_PARTNER_VIOLENCE',
        checked: false,
        section: false,
      },
      {
        title: 'Stalking',
        value: 'stalking',
        checked: false,
        section: false,
      },
      {
        title: 'Weapon on company property',
        value: 'WEAPON_ON_COMPANY_PROPERTY',
        checked: false,
        section: false,
      },
      {
        title: 'Concerning communication',
        value: 'CONCERNING_COMMUNICATION',
        checked: false,
        section: false,
      },
      {
        title: 'Risk of self harm',
        value: 'RISK_OF_SELF_HARM',
        checked: false,
        section: false,
      },
      {
        title: 'Risk to others',
        value: 'RISK_TO_OTHERS',
        checked: false,
        section: false,
      },
      {
        title: 'Anonymous communication',
        value: 'ANONYMOUS_COMMUNICATION',
        checked: false,
        section: false,
      },
      {
        title: 'Vandalism',
        value: 'VANDALISM',
        checked: false,
        section: false,
      },
      {
        title: 'Other',
        value: 'OTHER',
        checked: false,
        section: false,
      },
    ],
  },
  {
    title: 'OSHA Violence Type',
    value: 'violence_type',

    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Criminal Intent',
        value: 'Criminal Intent',
        checked: false,
        section: false,
      },
      {
        title: 'Customer / Client',
        value: 'Customer / Client',
        checked: false,
        section: false,
      },
      {
        title: 'Worker on Worker',
        value: 'Worker on Worker',
        checked: false,
        section: false,
      },
      {
        title: 'Personal Relationship',
        value: 'Personal Relationship',
        checked: false,
        section: false,
      },
    ],
  },
  {
    title: 'Disposition',
    value: 'disposition',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Substantiated',
        value: 'substantiated',
        checked: false,
        section: false,
      },
      {
        title: 'Unsubstantiated',
        value: 'unsubstantiated',
        checked: false,
        section: false,
      },
      {
        title: 'Inconclusive',
        value: 'inconclusive',
        checked: false,
        section: false,
      },
      {
        title: 'Other',
        value: 'other',
        checked: false,
        section: false,
      },
    ],
  },
  {
    title: 'Outcome',
    value: 'outcome',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Injury',
        value: 'injury',
        checked: false,
        section: false,
      },
      {
        title: 'Termination',
        value: 'termination',
        checked: false,
        section: false,
      },
    ],
  },
]
const pages: { [key: string]: { url: string; id: number }[] } = {
  zip: [
    {
      url: '/images/testDocument.jpg',
      id: 1,
    },
    {
      url: '/images/testDocument.jpg',
      id: 2,
    },
    {
      url: '/images/testDocument.jpg',
      id: 3,
    },
    {
      url: '/images/testDocument.jpg',
      id: 4,
    },
    {
      url: '/images/testDocument.jpg',
      id: 5,
    },
    {
      url: '/images/testDocument.jpg',
      id: 6,
    },
  ],
  xls: [
    {
      url: '/images/exportReportXlsTemplate.png',
      id: 1,
    },
    {
      url: '/images/exportReportXlsTemplate.png',
      id: 2,
    },
    {
      url: '/images/exportReportXlsTemplate.png',
      id: 3,
    },
    {
      url: '/images/exportReportXlsTemplate.png',
      id: 4,
    },
  ],
  csv: [
    {
      url: '/images/exportReportCsvTemplate.png',
      id: 1,
    },
    {
      url: '/images/exportReportCsvTemplate.png',
      id: 2,
    },
    {
      url: '/images/exportReportCsvTemplate.png',
      id: 3,
    },
    {
      url: '/images/exportReportCsvTemplate.png',
      id: 4,
    },
  ],
}

const imageHoverStyle = {
  height: '90%',
  borderRadius: '5rem',
  position: 'relative',
  ':before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0)',
  },

  ':hover::before ': {
    backgroundColor: colors.TAG_SECONDARY_BLUE,
    opacity: 0.5,
  },

  button: {
    position: 'absolute',
    top: '60%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ' -ms-transform': 'translate(-50%, -50%)',
    opacity: 0,
  },

  ':hover button': {
    opacity: 1,
  },
}

const calendarBox = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  padding: '1rem',
  border: '1px solid #A4C8E9',
  borderRadius: '.5rem',
}

const pagesBox = {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '3.33%',
  rowGap: '1.8rem',
}

export default {
  imageHoverStyle,
  pages,
  testFilter,
  calendarBox,
  pagesBox,
}
